module.exports = __webpack_public_path__ + "img/reward.053b0869.svg";